import {useTranslation} from "react-i18next";
import {StatisticsGroupWrapper, TransportCategory} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {InsightPieChart, InsightPieChartProps} from "../InsightPieChart/InsightPieChart";
import {PieChartData} from "../../chart/PieChart/PieChart";

export type LoadRejectInsightProps = Pick<InsightPieChartProps, 'containerProps' | 'loading' | 'id'> & {
    statistics?: StatisticsGroupWrapper,
    category?: TransportCategory
}

export const LoadRejectInsight = (props: LoadRejectInsightProps) => {
    const {statistics, category, ...rest} = props

    const {t} = useTranslation()

    const statsName = useMemo(() => {
        return statistics?.name
    }, [statistics])

    const data: PieChartData[] | undefined = useMemo(() => {
        if (statistics) {
            const loads = statistics.trucking.getTotalLoads(category)
            const rejects = statistics.trucking.getTotalRejects(category)

            return [{
                name: t("commons.entity.insights.chart.loadreject.dataset.loads.label", "Loads"),
                value: loads
            }, {
                name: t("commons.entity.insights.chart.loadreject.dataset.rejects.label", "Rejects"),
                value: rejects
            }]
        }

        return undefined
    }, [statistics, category, t])

    return (
        <InsightPieChart
            {...rest}
            title={t<string>("common.insight.loadreject", "{{statsName}} Loads vs Rejects", {
                statsName: statsName ?? ""
            })}
            icon={"chartHistogram"}
            data={data}/>
    )
}
